import { useSelector } from 'react-redux';
import WdSearch from '@main/core/WdSearch';
import { selectFlatNavigation } from 'app/store/core/navigationSlice';

function NavigationSearch(props) {
  const { variant, className } = props;
  const navigation = useSelector(selectFlatNavigation);

  return <WdSearch className={className} variant={variant} navigation={navigation} />;
}

export default NavigationSearch;
